'use client'

import { motion } from 'motion/react'
import { usePrefersReducedMotion } from '../morphDialog/usePrefersReducedMotion'

const EASE_OUT = [0.23, 1, 0.32, 1] as const

// A green disc that settles in, then draws its check mark. With reduced motion
// it simply fades in.
export function SuccessCheck() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <motion.span
      aria-hidden="true"
      className="flex size-14 items-center justify-center rounded-full bg-affirmative text-white"
      initial={
        prefersReducedMotion ? { opacity: 0 } : { opacity: 0, scale: 0.6 }
      }
      animate={{ opacity: 1, scale: 1 }}
      transition={
        prefersReducedMotion
          ? { duration: 0.2 }
          : { type: 'spring', duration: 0.45, bounce: 0.35 }
      }
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <motion.path
          d="M5 12.5l4.5 4.5L19 7.5"
          initial={prefersReducedMotion ? false : { pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.32, delay: 0.16, ease: EASE_OUT }}
        />
      </svg>
    </motion.span>
  )
}
